import React from 'react';
import styles from './consultancyStep.module.css';

interface OutlineLightButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  type?: 'button' | 'submit';
  icon?: React.ReactNode;
  compact?: boolean;
  medium?: boolean;
  disabled?: boolean;
}

const buttonClassName = (
  compact: boolean,
  medium: boolean,
) => [
  styles.outlineLightButton,
  compact ? styles.outlineLightButtonCompact : '',
  medium ? styles.outlineLightButtonMedium : '',
].filter(Boolean).join(' ');

const OutlineLightButton: React.FC<OutlineLightButtonProps> = ({
  children,
  onClick,
  href,
  type = 'button',
  icon,
  compact = false,
  medium = false,
  disabled = false,
}) => {
  const className = buttonClassName(compact, medium);

  if (href && !disabled) {
    return (
      <a
        className={className}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {icon}
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={className}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      title={disabled ? 'Link ainda não disponível.' : undefined}
    >
      {icon}
      {children}
    </button>
  );
};

export default OutlineLightButton;
